import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import "../Navbar.css";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { EditModeContext } from "../Context/EditModeContext";

const NavbarComponent = () => {
    const [sidebar, setSidebar] = useState(false);
    const { t } = useTranslation();
    const {editMode, setEditMode} = useContext(EditModeContext);
    
    const onClickLanguageChange = (e: any) => {
        const language = e.target.value;
        i18n.changeLanguage(language); //change the language
    }
    const toggleSidebar = () => setSidebar(!sidebar);

    return (
        <>
            <div className="navbar text-white bg-dark" style={{position: "absolute"}}>
                <span role="button" className="menu-bars bg-dark text-white" onClick={toggleSidebar}><i className="bi bi-list"/></span>
            </div>
            <nav className={"text-white bg-dark "+(sidebar ? "nav-menu active" : "nav-menu")}  >
                
                <div className="nav-menu-items">

                    <div style={{  padding: "8px 16px", width: "100%"}}>
                        <span className="btn-group w-100" role="group" aria-label="Basic radio toggle button group">
                            <input type="radio" className="btn-check" name="btnradio" id="btnradio1" value="en" autoComplete="off" checked={i18n.language === "en"} onChange={onClickLanguageChange}/>
                            <label className="btn btn-outline-light" htmlFor="btnradio1">English</label>
                            <input type="radio" className="btn-check" name="btnradio" id="btnradio3" value="it" autoComplete="off" checked={i18n.language === "it"} onChange={onClickLanguageChange}/>
                            <label className="btn btn-outline-light" htmlFor="btnradio3">Italiano</label>
                        </span>
                    </div>
                    <div style={{  padding: "8px 16px"}}>
                        <span className="btn-group w-100" role="group" aria-label="Basic radio toggle button group">
                            <input type="radio" className="btn-check" name="editradio" id="editradio" autoComplete="off" checked={editMode} onChange={e => setEditMode(true)}/>
                            <label className="btn btn-outline-light" htmlFor="editradio">{t("button-editmode")}</label>
                            <input type="radio" className="btn-check" name="viewradio" id="viewradio" autoComplete="off" checked={!editMode} onChange={e => setEditMode(false)}/>
                            <label className="btn btn-outline-light" htmlFor="viewradio">{t("button-viewmode")}</label>
                        </span>
                    </div>
                    {/* <span className="btn-group" role="group" aria-label="Basic radio toggle button group">
                        <input type="radio" className="btn-check" name="editradio" id="editradio" autoComplete="off" checked={props.editMode} onChange={e => props.setEditMode(true)}/>
                        <label className="btn btn-outline-primary" htmlFor="editradio">{t("button-editmode")}</label>
                        <input type="radio" className="btn-check" name="viewradio" id="viewradio" autoComplete="off" checked={!props.editMode} onChange={e => props.setEditMode(false)}/>
                        <label className="btn btn-outline-primary" htmlFor="viewradio">{t("button-viewmode")}</label>
                    </span> */}

                    {/* <span role="button" className="menu-bars bg-dark text-white" onClick={toggleSidebar}><i className="bi bi-list"/></span> */}
                    <div role="button" className="nav-text" onClick={toggleSidebar}>
                        <Link to="/">
                            <i className="bi bi-house-door-fill"></i>&nbsp;Initiative Tracker
                        </Link>
                    </div>
                    <details className="nav-text">
                        <summary >
                            <span>Database</span>
                        </summary>
                        <summary >
                            <div role="button" onClick={toggleSidebar}>
                                <Link to="/sources">
                                    <i className="bi bi-book"></i>&nbsp;{t("navbar-sources")}
                                </Link>
                            </div>
                            <div role="button" onClick={toggleSidebar}>
                                <Link to="/spells">
                                    <i className="bi bi-magic"></i>&nbsp;{t("navbar-spells")}
                                </Link>
                            </div>
                            <div role="button" onClick={toggleSidebar}>
                                <Link to="/monsters">
                                    <i className="bi bi-bug"></i>&nbsp;Monsters
                                </Link>
                            </div>
                            <div role="button" onClick={toggleSidebar}>
                                <Link to="/importdata">
                                    <i className="bi bi-upload"></i>&nbsp;Import data
                                </Link>
                            </div>
                        </summary>
                    </details>
                </div>
            </nav>
        </>
    );
}

export default NavbarComponent;